import { allUserPermissions, rootScope } from './../states/user';
import { useAtomValue } from 'jotai';

export const useUserPermissions = () => {
  const permissions = useAtomValue(allUserPermissions, rootScope);

  return permissions;
};
